module.exports = __webpack_public_path__ + "static/img/carac4.b75d6338.jpg";